// extracted by mini-css-extract-plugin
export default {"container":"WhatsappComponent_container__G2n+G","whatsappButton":"WhatsappComponent_whatsappButton__r3X5V","whatsappWrapper":"WhatsappComponent_whatsappWrapper__Km1Ur"};